import { render, staticRenderFns } from "./AutomaticPostingSetting.vue?vue&type=template&id=8ad56898&scoped=true"
import script from "./AutomaticPostingSetting.vue?vue&type=script&lang=js"
export * from "./AutomaticPostingSetting.vue?vue&type=script&lang=js"
import style0 from "./AutomaticPostingSetting.vue?vue&type=style&index=0&id=8ad56898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad56898",
  null
  
)

export default component.exports